import { useParams } from 'react-router-dom';
import { useGetFamiliesQuery } from '../app/api-slice';
import { LoadingPage } from './loading-page';
import { ErrorPage } from './error-page';
import { useMessages2 } from '../hooks/useLanguage';
import { ChooseSubFamily } from '../view/choose-sub-family';
import { useImageURLToFamily } from '../hooks/useImageURLtoFamily';
import { useDataRequestLang } from '../app/main-slice';
import { useFamilyName } from '../hooks/navigation-names';
import { PageMetadata } from '../view/page-metadata';

export const ChooseSubFamilyPage = () => {

    const lang = useDataRequestLang();
    const { categoryId, subFamilyId } = useParams();
    const { data: subFamilies = [], isLoading, isSuccess, error } = useGetFamiliesQuery({
        lang,
        category: subFamilyId!
    });
    const { data: families = [] } = useGetFamiliesQuery({
        lang,
        category: categoryId!
    });

    const familyName = useFamilyName(categoryId!, subFamilyId!);

    const {isLoading: isLoadingMessage, isSuccess: isSuccessMessage, messages } = useMessages2();

    const familiesWithImages = useImageURLToFamily(subFamilies);

    let content;
    if(isLoading || isLoadingMessage) {
        content = <LoadingPage/>;
    } else if(isSuccess && categoryId && subFamilyId && isSuccessMessage) {
        content = <ChooseSubFamily categoryId={categoryId} subFamilies={familiesWithImages} familyName={familyName || ""} />
    } else {
        content = <ErrorPage error={error}/>
    }

    return <>
        <PageMetadata pageTitle={familyName} />
        { content }
    </>

}